import { createFeature, createReducer, on } from '@ngrx/store';
import { TitleActions } from './title.actions';

const TITLE_FEATURE_KEY = 'title';

export interface State {
  currentTitle: string | null;
}

export const initialTitleState: State = {
  currentTitle: null,
};

export const titleFeature = createFeature({
  name: TITLE_FEATURE_KEY,
  reducer: createReducer(
    initialTitleState,
    on(TitleActions.updateTitle, (state, action) => ({
      ...state,
      currentTitle: action.title,
    })),
  ),
});
